// extracted by mini-css-extract-plugin
export default {"main":"PublicLayout_main__DeAem","mainContent":"PublicLayout_mainContent__Vwu9a"};